import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule} from '@angular/material/button';

import { Avatar } from './avatar.component';

@NgModule({
  declarations: [
    Avatar
  ],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [
    Avatar
  ]
})
export class AvatarModule { }
